import EquipmentTableFilter from "./equipment-table-filter";

const EquipmentFilters = {
  Table: EquipmentTableFilter,
};

export default EquipmentFilters;
